<div class="container-fluid p-3">

  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ payload?.proposal_name }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">


        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <!-- <div class="container-fluid"> -->

  <!-- <div class="row mb-4">
    <div class="col-lg-8">
      <div class="card shadow-sm border-0">
        <div class="card-body p-4">
          <div class="d-flex align-items-center mb-3">
            <i class="pi pi-file text-primary me-2"></i>
            <h5 class="card-title mb-0">WBS Document</h5>
          </div>
          
          <p class="text-muted mb-4">Please upload your document in PDF, DOCX, CSV, JPEG, JPG, or PNG format (Max size: 200MB)</p>
          <div class="upload-container mb-4" 
               *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
            <div class="upload-area p-4 text-center border rounded" >
             
              
              <p-fileUpload 
                mode="basic" 
                chooseLabel="Browse Files" 
                (uploadHandler)="onUpload($event)"
                [auto]="true" 
                [customUpload]="true" 
                #fileUpload 
                [multiple]="false" 
                [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'" 
                [maxFileSize]="209715200"
                styleClass="p-button-rounded p-button-outlined">
              </p-fileUpload>
            </div>
          </div>
          <div *ngIf="uploadedFileName || uploadedUrl">
            <div class="uploaded-file-card p-3 bg-light rounded d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <i class="pi pi-file me-3 text-primary" style="font-size: 1.5rem;"></i>
                <div>
                  <p class="mb-0 fw-semibold">
                    <a [href]="apiUrl + uploadedUrl" target="_blank" class="text-decoration-none">
                      {{ uploadedFileName || getFileName(uploadedUrl) }}
                    </a>
                  </p>
                  <small class="text-muted">Uploaded successfully</small>
                </div>
              </div>
              <div class="d-flex gap-2">
                <a [href]="apiUrl + uploadedUrl" target="_blank" class="btn btn-sm btn-outline-primary"  *ngIf="uploadedUrl">
                  <i class="pi pi-eye"></i>
                </a>
                  <i class="pi pi-times"  (click)="clearUpload(fileUpload)" *ngIf="uploadedFileName"></i>
              </div>
            </div>
          </div>

          <div *ngIf="!uploadedFileName && !uploadedUrl && 
                      !(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || 
                      (stepDetails?.step_status != 'approved' && userID == 6))" 
               class="no-file-placeholder p-3 text-center bg-light rounded">
            <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem;"></i>
            <p class="mb-0 text-muted">No files uploaded</p>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- </div> -->

  <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
    <div (click)="toggleSection('fileUpload')"
        class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
        <h3 class="text-lg font-semibold  flex items-center">
            <span
                class="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mr-3 text-sm">
                <i class="pi pi-upload"></i>
            </span>
          Upload WBS File
        </h3>
        <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['fileUpload'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
    </div>
    <div *ngIf="expandedSections['fileUpload']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">

        <div class="flex items-center">
            <label class="block font-medium text-slate-700 mb-2 w-1/3">
                Upload WBS File (in Excel format)
                <span class="text-red-500">*</span>
            </label>
            <input pInputText id="file_name" type="file" accept=".xlsx" (change)="onFileUpload($event)"
                class="w-2/3 px-4 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                placeholder="Enter File Name" autocomplete="off" />
        </div>
    <div *ngIf="aipData && aipData.length > 0" class="border border-blue-200 rounded-lg p-4 mb-2 bg-white flex items-center justify-between">
        <div class="flex items-center gap-3">
            <i class="pi pi-file-excel text-2xl text-green-600"></i>
            <div>
                <div class="font-semibold text-gray-800">
                    {{ aipData[0]?.file_name || 'WBS.xlsx' }}
                </div>
                <div class="text-xs text-gray-500">Uploaded on: 
                    {{ aipData[0]?.modified_on ? (aipData[0]?.modified_on | date:'short') : (aipData[0]?.created_on | date:'short') }}
                </div>
                <div class="text-xs text-gray-500">Status: 
                    <span *ngIf="aipData[0]?.status == 1; else notActive">Active</span>
                    <ng-template #notActive>Inactive</ng-template>
                </div>
            </div>
        </div>
        <div class="flex items-center gap-2">
            <a [href]="aipData[0]?.document" target="_blank" class="btn btn-sm btn-outline-primary" *ngIf="aipData[0]?.document">
                <i class="pi pi-eye"></i>
            </a>
        </div>
    </div>
     

    </div>
  </div>
  
    


  <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
    <div (click)="toggleSection('uploads')"
        class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
        <h3 class="text-lg font-semibold flex items-center gap-2">
            <span
                class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
                <i class="pi pi-upload"></i>
            </span>
           Upload Supportive Documents
        </h3>
        <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
    </div>
    <div *ngIf="expandedSections['uploads']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
        <app-upload-document [isEditable]="stepDetails.can_edit" >      </app-upload-document>
    </div>
  </div>
  </div>